export const MAINTENANCE_TYPE_OPTIONS = [
	{ value: 'note', labelKey: 'general_note', shortLabelKey: 'general_note_short' },
	{ value: 'battery', labelKey: 'battery_replacement', shortLabelKey: 'battery_short' },
	{ value: 'panel', labelKey: 'panel_change', shortLabelKey: 'panel_short' },
	{ value: 'technician', labelKey: 'technician_check', shortLabelKey: 'technician_short' },
]

export const MAINTENANCE_RECORD_KEYS = {
	battery: 'currReplacement',
	panel: 'currPanel',
	technician: 'currCheck',
}

export const MAINTENANCE_RECORD_TYPES = ['battery', 'panel', 'technician']

export const MAINTENANCE_SAVE_MESSAGE_KEYS = {
	battery: 'Battery replacement recorded successfully',
	panel: 'Panel change recorded successfully',
	technician: 'Technician check recorded successfully',
}

export const MAINTENANCE_HISTORY_CONFIG = {
	battery: {
		historyKey: 'batteryReplacementHistory',
		loadingKey: 'batteryHistoryLoading',
		loadedKey: 'batteryHistoryLoaded',
	},
	panel: {
		historyKey: 'panelReplacementHistory',
		loadingKey: 'panelHistoryLoading',
		loadedKey: 'panelHistoryLoaded',
	},
	technician: {
		historyKey: 'technicianCheckHistory',
		loadingKey: 'checkHistoryLoading',
		loadedKey: 'checkHistoryLoaded',
	},
}

export function getLoggedUserDisplayName(user = {}) {
	const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim()
	return fullName || user.username || user.email || ''
}

export function getTodayIsoDate() {
	return new Date().toISOString().split('T')[0]
}

export function getDeviceSensorCode(device) {
	return device.sensor_code
		|| device.device_code
		|| device.status?.sensorCode
		|| device.device_id
}

export function createMaintenanceRecord(maintenanceType, overrides = {}) {
	return {
		site_id: null,
		room_id: null,
		sensor_code: null,
		maintenance_type: maintenanceType,
		maintenance_date: getTodayIsoDate(),
		technician_name: '',
		note_text: '',
		user_info: '',
		created_at: null,
		updated_by: '',
		...overrides,
	}
}

export function buildDeviceMaintenanceFields(device, loggedUser) {
	const technicianName = getLoggedUserDisplayName(loggedUser)
	return {
		site_id: device.site_id || device.status?.siteId,
		room_id: device.room_id || device.status?.roomId,
		sensor_code: getDeviceSensorCode(device),
		user_info: technicianName,
		updated_by: loggedUser?.id || '',
		...(technicianName ? { technician_name: technicianName } : {}),
	}
}
